<template>
    <component :is="currentIcon" />
</template>

<script setup lang="ts">
    import IconClose from './Icons/IconClose.vue';
    import IconInfo from './Icons/IconInfo.vue';
    import IconLive from './Icons/IconLive.vue';
    import IconMyTv from './Icons/IconMyTv.vue';
    import IconNav from './Icons/IconNav.vue';
    import IconNavChannels from './Icons/IconNavChannels.vue';
    import IconPlay from './Icons/IconPlay.vue';
    import IconPlaySingle from './Icons/IconPlaySingle.vue';
    import IconRestart from './Icons/IconRestart.vue';
    import IconSkip from './Icons/IconSkip.vue';
    import IconSubtitle from './Icons/IconSubtitle.vue';
    import IconVolumeChange from './Icons/IconVolumeChange.vue';
    import IconUp from './Icons/IconUp.vue';
    import IconDown from './Icons/IconDown.vue';

    const props = defineProps<{
        iconName: string | undefined;
    }>();

    const icons: Record<string, ReturnType<typeof defineComponent>> = {
        IconClose,
        IconInfo,
        IconDown,
        IconUp,
        IconLive,
        IconMyTv,
        IconNav,
        IconNavChannels,
        IconPlay,
        IconPlaySingle,
        IconRestart,
        IconSkip,
        IconSubtitle,
        IconVolumeChange
    };

    const currentIcon = computed(() => {
        return props.iconName ? icons[props.iconName] : '';
    });
</script>
